import _ from "lodash"
import { Query } from "../HealthcareUsageReport/types/CohortQuery"

export interface Permission {
    cb: boolean
    hru: boolean
    pwv: boolean
    qb: boolean
    companyQueryHistory: boolean
    owner: boolean
    example: boolean
    shared: boolean
}

export const canEditQuery = ({ cb, hru, pwv, qb, owner, example, shared }: Permission) => {
    if (owner) {
        return !shared && !example
    } else {
        return false
    }
}

export const canKillQuery = ({ cb, hru, pwv, qb, owner, example, shared }: Permission) => {
    return owner
}

export const isCohortExportable = (query: Query) => {
    return query.trackable && !_.isNil(query.sparkQuery) && !_.isNil(query.sparkQuery.response)
}